import { injectable } from 'inversify';
import type { CallbackSubscription } from '@/engine/Utilities/CallbackManager';
import { CallbackManager } from '@/engine/Utilities/CallbackManager';
import { DisposablesBasket } from '@/engine/Utilities/DisposablesBasket';
import type { ICubeButtonsController } from './interfaces';

export enum ArrowDirection {
  Left = 'left',
  Right = 'right',
  Up = 'up',
  Down = 'down'
}

@injectable()
export class CubeButtonsController implements ICubeButtonsController {
  private readonly _arrowClickedListeners: CallbackManager<(direction: ArrowDirection) => void>;

  private readonly _arrowsVisibilityChangedListeners: CallbackManager<(visibility: boolean) => void>;

  private readonly _subscriptions = new DisposablesBasket();

  public constructor() {
    this._arrowsVisibilityChangedListeners = new CallbackManager();
    this._arrowClickedListeners = new CallbackManager();
  }

  public trackButtonClicked(callback: (direction: ArrowDirection) => void): CallbackSubscription {
    return this._arrowClickedListeners.subscribe(callback);
  }

  public changeDirection(direction: ArrowDirection): void {
    this._arrowClickedListeners.invoke(direction);
  }

  public changeButtonsVisibility(visibility: boolean): void {
    this._arrowsVisibilityChangedListeners.invoke(visibility);
  }

  public onButtonsVisibilityChanged(callback: (visibility: boolean) => void): void {
    this._subscriptions.add(this._arrowsVisibilityChangedListeners.subscribe(callback));
  }

  public dispose(): void {
    this._subscriptions.dispose();
  }
}
